/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Save_ChangesInputs */

const vi_order_save_changes = /** @type {(inputs: Order_Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu thay đổi`)
};

/**

* @param {Order_Save_ChangesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_save_changes = /** @type {((inputs?: Order_Save_ChangesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Save_ChangesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_save_changes(inputs)
});